import { useState } from "react";
import { ChoiceList } from "../widgets/ChoiceList";
import { supportedLanguageItems } from "../../ruleSets/allRules";
import { allSpeakVariants } from "../../speak/meSpeak";
import { speakDefaults } from "../../speak/speakPhonemes";
import { RangeSlider } from "../widgets/RangeSlider";
import { supportedEnglishAccents } from "../../ruleSets/accentRules";
import { supportedSpanishAccents } from "../../ruleSets/spanishToIpa";

/** show options for multi-part dialog input */
export function PartsTable() {
  const [language, setLanguage] = useState('English');
  const [accent, setAccent] = useState('Western US');
  const [accents, setAccents] = useState(supportedEnglishAccents);
  const [voice, setVoice] = useState(speakDefaults.variant as string);
  const [volume, setVolume] = useState(speakDefaults.amplitude as number);
  const [pitch, setPitch] = useState(speakDefaults.pitch as number);
  const [speed, setSpeed] = useState(speakDefaults.speed as number);
  const [wordgap, setWordgap] = useState(speakDefaults.wordgap as number);
  const [pan, setPan] = useState(0);

  /** switch language & adjust accents */
  function changeLanguage(language: string) {
    setLanguage(language);
    if (language === 'English') {
      setAccents(supportedEnglishAccents);
      setAccent('Western US');
    } else if (language === 'Spanish') {
      setAccents(supportedSpanishAccents);
      setAccent('Spain');
    } else {
      setAccents([]);
      setAccent('');
    }
  }

  return (<table>
    <thead><tr><th>property</th><th>default</th><th>options</th><th>value</th></tr></thead>
    <tbody>
      <tr>
        <td>language</td>
        <td>English</td>
        <td><ChoiceList items={supportedLanguageItems} selectedItem={language} onSelect={changeLanguage} /></td>
        <td>{`"language":"${language}"`}</td>
      </tr>
      <tr>
        <td>accent</td>
        <td>Western US</td>
        <td>{accent === '' ? <></> : <ChoiceList items={accents} selectedItem={accent} onSelect={setAccent} />}</td>
        <td>{accent === '' ? '' : `"accent":"${accent}"`}</td>
      </tr>
      <tr>
        <td>voice</td>
        <td>fiona</td>
        <td><ChoiceList items={allSpeakVariants} selectedItem={voice} onSelect={setVoice} /></td>
        <td>{`"voice":"${voice}"`}</td>
      </tr>
      <tr>
        <td>volume</td>
        <td>{speakDefaults.amplitude}</td>
        <td><RangeSlider value={volume} min={10} max={200} onChange={setVolume} /></td>
        <td>{`"volume":${volume}`}</td>
      </tr>
      <tr>
        <td>pitch</td>
        <td>{speakDefaults.pitch}</td>
        <td><RangeSlider value={pitch} min={10} max={100} onChange={setPitch} /></td>
        <td>{`"pitch":${pitch}`}</td>
      </tr>
      <tr>
        <td>speed</td>
        <td>{speakDefaults.speed}</td>
        <td><RangeSlider value={speed} min={50} max={290} onChange={setSpeed} /></td>
        <td>{`"speed":${speed}`}</td>
      </tr>
      <tr>
        <td>wordgap</td>
        <td>{speakDefaults.wordgap}</td>
        <td><RangeSlider value={wordgap} min={0} max={20} onChange={setWordgap} /></td>
        <td>{`"wordgap":${wordgap}`}</td>
      </tr>
      <tr>
        <td>pan</td>
        <td>0</td>
        <td><RangeSlider value={pan} min={-100} max={100} onChange={setPan} /></td>
        <td>{`"pan":${pan / 100}`}</td>
      </tr>
    </tbody>
  </table>);
}
